export const BANK_RECONCILIATION_REPORT_LABELS = {
    reportType: "Reconciliation report",
    reconciledTransactions: "Reconciled transactions",
    unreconciledTransactions: "Unreconciled transactions",
    depositAndCredits: "Deposits and credits",
    checksAndPayments: "Checks and payments",
    noClearedTransactions: "No cleared transactions in this reconciliation.",
    noUnreconciledTransactions:
        "No unreconciled transactions at statement end date.",
    cashIn: "Cash in",
    cashOut: "Cash out",
    cashBalancePerBankStatement: "Cash balance per bank statement",
    endingReconciledBalance: "Ending reconciled balance",
    endingPeriodBalance: "Ending period balance",
    unreconciledTransactionsSummary: "Unreconciled transactions",
    differenceToReconcile: "Difference to reconcile",
    statementBalanceNotAvailable: "Statement balance not available",
    subtotal: "Subtotal",
    dateColumn: "Date",
    counterpartyColumn: "Counterparty",
    descriptionColumn: "Description",
    amountColumn: "Amount",
    datePrepared: "Date prepared",
    dateReviewed: "Date reviewed",
    preparedBy: "Prepared by",
    reviewedBy: "Reviewed by",
} as const;

export function balancesAsOfLabel(closingDateLabel: string): string {
    return `Balances as of ${closingDateLabel}`;
}

export function beginningReconciledBalanceLabel(
    openingDateLabel: string,
): string {
    return `Beginning reconciled balance as of ${openingDateLabel}`;
}

export function periodEndedLabel(closingDateLabel: string): string {
    return `Period ended ${closingDateLabel}`;
}

export function bankReconciliationReportDirectionalLabels(
    accountKind: "bank" | "liability",
) {
    if (accountKind === "liability") {
        return {
            cashIn: "Payments",
            cashOut: "Charges",
            depositAndCredits: "Payments",
            checksAndPayments: "Charges",
        };
    }

    return {
        cashIn: BANK_RECONCILIATION_REPORT_LABELS.cashIn,
        cashOut: BANK_RECONCILIATION_REPORT_LABELS.cashOut,
        depositAndCredits: BANK_RECONCILIATION_REPORT_LABELS.depositAndCredits,
        checksAndPayments: BANK_RECONCILIATION_REPORT_LABELS.checksAndPayments,
    };
}
